module.exports = __webpack_public_path__ + "static/locales/th.1-GYLfO.json";